import PropTypes from 'prop-types';

export const propTypes = {
    backgroundColor: PropTypes.string,
    onChange: PropTypes.func,
};
